import { useState, useEffect } from 'react';

export default function useDataLayerVisibility() {
  const [dataLayersVisible, setDataLayersVisible] = useState(() => {
    try {
      const saved = localStorage.getItem('siteTakeoffV2_dataLayers');
      return saved ? JSON.parse(saved) : { geofence: true, propertyLines: true, restrictedAreas: true, serviceAreas: true };
    } catch (_) {
      return { geofence: true, propertyLines: true, restrictedAreas: true, serviceAreas: true };
    }
  });

  // Listen to localStorage changes from MapLayerControl so toggles stay in sync
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'siteTakeoffV2_dataLayers' && e.newValue) {
        try { setDataLayersVisible(JSON.parse(e.newValue)); } catch (_) {}
      }
    };
    window.addEventListener('storage', onStorage);
    // Also poll periodically since same-tab writes don't fire 'storage' event
    const interval = setInterval(() => {
      try {
        const saved = localStorage.getItem('siteTakeoffV2_dataLayers');
        if (saved) {
          const parsed = JSON.parse(saved);
          setDataLayersVisible(prev =>
            JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev
          );
        }
      } catch (_) {}
    }, 500);
    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  return { dataLayersVisible, setDataLayersVisible };
}
